module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00076-fs8.8619fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00076-fs8.png
// module id = 229
// module chunks = 0